var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSouthAmerica(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 10.05 4.7 8.26 5.87 6.87L9 10V11C9 12.1 9.9 13 11 13V18.59C11 18.86 11.11 19.11 11.29 19.3L12 20C7.58 20 4 16.42 4 12ZM13 19.94V18L16.75 12.38C16.91 12.13 17 11.84 17 11.55V10.5C17 9.95 16.55 9.5 16 9.5H14.5L13.1 7.75C12.72 7.28 12.15 7 11.54 7H8V5.07C9.18 4.39 10.54 4 12 4C16.41 4 20 7.59 20 12C20 16.07 16.94 19.44 13 19.94Z",
    fill: "#E01E00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthAmerica);
export default __webpack_public_path__ + "static/media/south_america.1deb08161d3869a1149ab8838b25ef40.svg";
export { ForwardRef as ReactComponent };